import { FieldMap } from '../../types/forms/fields'
import { LaborEntryType } from '../types/laborEntry'
import { cervicalExamField } from './cervicalExam'
import { contractionField } from './contraction'
import { fhrField } from './fhr'
import { medicationField } from './medication'
import { narrativeField } from './narrative'
import { procedureField } from './procedure'
import { laborVitalSignsField } from './vitals'

export const laborEntryFields: Record<LaborEntryType, FieldMap> = {
  [LaborEntryType.VITALS]: laborVitalSignsField,
  [LaborEntryType.CERVICAL_EXAM]: cervicalExamField,
  [LaborEntryType.FHR]: fhrField,
  [LaborEntryType.CONTRACTION]: contractionField,
  [LaborEntryType.MEDICATION]: medicationField,
  [LaborEntryType.NARRATIVE]: narrativeField,
  [LaborEntryType.PROCEDURE]: procedureField,
}
